import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { callWithPromise } from "../utility";
import { apiService } from "../service/common";

 
// const setPermisssion = createAsyncThunk(
//   "setPermisssion",
//   async (data, { rejectWithValue }) => {
//     try { 
//       return await callWithPromise("users/getUserPermissions", data);
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

// const SetAuthenticatedStore = createAsyncThunk(
//   "setAuthenticatedStore",
//   async (data, { rejectWithValue }) => {
//     try {
//       return await callWithPromise("getUser", data);
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

const SetGlobalValues = createAsyncThunk(
  "SetGlobalValues",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiService({
        url: "globalsetting/get-specific-global-values",
      });

      if (res?.data) return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const setStoresType = createAsyncThunk(
  "setStoresType",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiService({
        url: `store/getStoreType/${data}`,
      });
      if (res?.data) return res.data.store_type;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
const initialState = {
  user: {},
  userRole: "",
  storeLength: 0,
  storeId: null,
  isHeadQuater: false,
  hqStoreId: null,
  // userId: null,
  storeName: "",
  storeType: "",
  storeStatus: "",
  globalValues: {},
  currency_sign: "",
  userProfileValues: {},
  branchNo: null,
  storeList: [],
  paramsId:null,
  fulfillmentStatusMap: {},
};
export const storeSlice = createSlice({
  name: "rootStore",
  initialState,
  reducers: {
    reset: () => initialState,
    setToken: (state, action) => {
      localStorage.setItem("authorization", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
    },
    setDefaultStoreId: (state, action) => {
      state.paramsId = action.payload;
    },
    setFulfillmentStatus: (state, action) => {
      const ls_orderId = action.payload?.orderId || "";
      if (!ls_orderId) return;
      if (!state.fulfillmentStatusMap) {
        state.fulfillmentStatusMap = {};
      }
      state.fulfillmentStatusMap[ls_orderId] = {
        ...(state.fulfillmentStatusMap[ls_orderId] || {}),
        ...(action.payload?.data || {}),
      };
    },
    fetchId: (state, action) => {
      if (action.payload) {
        state.storeId = action.payload.item.store_id;
        state.isHeadQuater =
          action.payload.item.isDefault == "Yes" ? true : false;
        state.storeName = action.payload.item.store_name;
        state.storeStatus = action.payload.item.store_status;
        state.storeType = action.payload.item.store_type;
      }
    },
   setAuthenticatedStore: (state,action) =>{ 
    state.userProfileValues = action.payload.userProfileValues;
    state.user = action.payload.user; 
    const role = action.payload?.role[0]; 
    state.userRole = role?.toLowerCase();

    state.storeLength = action.payload?.store?.length;
    state.storeList = action.payload.store;

    state.storeId = action.payload.storeId;
    state.isHeadQuater = action.payload.isDefault == "Yes" ? true : false;
    state.storeStatus = action.payload.storeStatus;
    state.branchNo = action.payload.branchNo;
    state.storeName = action.payload.storeName;
    state.storeType = action.payload.storeType;
    state.hqStoreId = action.payload.hqStoreId;
   }
  },

  extraReducers: (builder) => {
    builder 
      // .addCase(SetAuthenticatedStore.fulfilled, (state, action) => { 
      //   state.userProfileValues = action.payload.userProfileValues;
      //   state.user = action.payload.user; 
      //   const role = action.payload?.role[0]; 
      //   state.userRole = role?.toLowerCase();

      //   state.storeLength = action.payload?.store?.length;
      //   state.storeList = action.payload.store;

      //   state.storeId = action.payload.storeId;
      //   state.isHeadQuater = action.payload.isDefault == "Yes" ? true : false;
      //   state.storeStatus = action.payload.storeStatus;
      //   state.branchNo = action.payload.branchNo;
      //   state.storeName = action.payload.storeName;
      //   state.storeType = action.payload.storeType;
      //   state.hqStoreId = action.payload.hqStoreId;
      // })
      // .addCase(SetAuthenticatedStore.pending, (state) => {
      //   state.loader = true;
      // })
      // .addCase(SetAuthenticatedStore.rejected, (state) => {
      //   state.loader = false;
      // })
      .addCase(SetGlobalValues.fulfilled, (state, action) => {
        state.globalValues = action.payload;
        state.currency_sign = action.payload.currency_sign?.field_value;
      })
      .addCase(SetGlobalValues.pending, (state) => {
        state.loader = true;
      })
      .addCase(SetGlobalValues.rejected, (state, action) => {
        state.loader = false;
      })
      .addCase(setStoresType.fulfilled, (state, action) => {
        state.storeType = action.payload;
      })
      .addCase(setStoresType.pending, (state) => {
        state.loader = true;
      })
      .addCase(setStoresType.rejected, (state, action) => {
        state.loader = false;
      });
  },
});

// Action creators are generated for each case reducer function

export const { reset, fetchId, setToken, setAuthenticatedStore, setDefaultStoreId, setFulfillmentStatus } =
  storeSlice.actions;
export { SetGlobalValues, setStoresType };
export default storeSlice.reducer;
